(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tdog-find-your-routine"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const WHY = {
      cleanser: 'Every routine starts here — it clears daily oil, sweat, and buildup without stripping your skin.',
      toner_tone: '5% glycolic acid gently exfoliates to smooth texture and even out tone and dark spots.',
      toner_breakouts: 'Its gentle exfoliation helps keep pores clear and calm breakouts.',
      toner_sensitive_note: ' Sensitive skin? Start with two to three nights a week.',
      serum_aging: 'Bakuchiol — a gentle, plant-based retinol alternative — supports renewal for smoother, firmer-looking skin.',
      serum_tone: 'Bakuchiol helps even tone and revive dull, tired skin over time.',
      serum_dry: 'A lightweight oil-serum that layers in nourishing hydration.',
      cream_dry: 'Multi-weight hyaluronic acid locks in lasting hydration — essential for dry, tight skin.',
      cream_aging: 'Daily hydration that helps soften the look of fine lines.',
      cream_default: 'Seals in moisture to finish the routine.',
      eye_eyes: 'Targets dark circles, puffiness, and tired-looking eyes in the delicate eye area.',
      eye_aging: 'Smooths and hydrates fine lines around the eyes.',
      beard_wash: 'Cleans daily buildup and leaves your beard softer and easier to manage.',
      beard_oil_dry: 'CBD + hemp softens coarse, brittle hair and comforts the skin underneath — no more itch.',
      beard_oil_default: 'Conditions your beard daily so it stays soft and healthy.',
      beard_scrub_flakes: 'Exfoliates the skin beneath your beard to clear flakes and calm itch.',
      beard_scrub_grow: 'Clears buildup and exfoliates the skin so your beard can grow in healthier and fuller.',
      body_wash: 'A rich, non-stripping daily cleanse.',
      body_lotion_dry: '5% urea + hyaluronic acid for dry, rough skin — lightweight and non-greasy.',
      body_lotion_default: 'Daily moisture to keep skin smooth.',
      face_bundle: 'Your full face routine in one — cleanse, exfoliate, treat, and hydrate, built to work together (and cheaper than buying separately).',
      beard_bundle: 'The complete beard system — wash, scrub, and oil that keep your beard clean, soft, and healthy.',
      full_bundle: 'Everything you flagged, handled — the complete face + beard + body system in one.'
    };

    const KICKERS = {
      headline: 'The headline pick',
      bundle: 'Complete routine',
      item: 'In your routine',
      addon: 'Smart add-on'
    };

    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const initQuiz = (quiz) => {
      if (quiz.dataset.tdogQuizInit === 'true') return;
      quiz.dataset.tdogQuizInit = 'true';

      const stepEls = Array.from(quiz.querySelectorAll('[data-tdog-step]'));
      const prevButton = quiz.querySelector('[data-tdog-prev]');
      const nextButton = quiz.querySelector('[data-tdog-next]');
      const progressLabel = quiz.querySelector('[data-tdog-progress-label]');
      const progressBar = quiz.querySelector('[data-tdog-progress-bar]');
      const result = quiz.querySelector('[data-tdog-result]');
      const summaryEl = quiz.querySelector('[data-tdog-summary]');
      const fallbackCard = quiz.querySelector('[data-tdog-rec-fallback]');
      const addAllButton = quiz.querySelector('[data-tdog-addall]');
      const addAllError = quiz.querySelector('[data-tdog-addall-error]');
      const restartButton = quiz.querySelector('[data-tdog-restart]');
      const gateForm = quiz.querySelector('[data-tdog-gate-form]');
      const gateInput = quiz.querySelector('[data-tdog-gate-input]');
      const gateError = quiz.querySelector('[data-tdog-gate-error]');

      const cards = {};
      quiz.querySelectorAll('[data-tdog-rec]').forEach((el) => {
        cards[el.getAttribute('data-tdog-rec')] = el;
      });

      if (!stepEls.length || !prevButton || !nextButton || !result || !gateForm || !gateInput) return;

      const GATE = 'gate';
      let index = 0;
      let hasNavigated = false;
      const reduceMotion = () =>
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const stepEl = (key) => stepEls.find((el) => el.getAttribute('data-step') === key);

      const values = (key) => {
        const el = stepEl(key);
        if (!el) return [];
        return Array.from(el.querySelectorAll('input:checked')).map((input) => input.value);
      };

      const single = (key) => values(key)[0] || '';

      const buildSequence = () => {
        const cats = values('cats');
        const seq = ['cats'];
        if (cats.indexOf('face') > -1) seq.push('face_type', 'face_concerns');
        if (cats.indexOf('beard') > -1) seq.push('beard_type', 'beard_concerns');
        if (cats.indexOf('body') > -1) seq.push('body_concerns');
        seq.push(GATE);
        return seq;
      };

      const pad = (n) => (n < 10 ? '0' + n : String(n));

      const render = (focusQuestion) => {
        const seq = buildSequence();
        if (index > seq.length - 1) index = seq.length - 1;
        const currentKey = seq[index];
        const isGate = currentKey === GATE;
        const totalQuestions = seq.length - 1;

        let activeEl = null;
        stepEls.forEach((el) => {
          const isActive = el.getAttribute('data-step') === currentKey;
          el.classList.toggle('is-active', isActive);
          if (isActive) activeEl = el;
        });

        if (progressLabel) {
          if (isGate) {
            progressLabel.textContent = 'One last step';
          } else if (totalQuestions > 1) {
            progressLabel.textContent = 'Question ' + (index + 1) + ' of ' + totalQuestions;
          } else {
            progressLabel.textContent = 'Question 1';
          }
        }

        if (progressBar) {
          const fraction = seq.length > 1 ? (index + 1) / seq.length : 0.08;
          progressBar.style.width = Math.max(8, Math.round(fraction * 100)) + '%';
        }

        if (activeEl && !isGate) {
          const num = activeEl.querySelector('[data-tdog-step-num]');
          if (num) num.textContent = 'Step ' + pad(index + 1);
        }

        prevButton.disabled = index === 0;
        nextButton.hidden = isGate;
        if (!isGate) {
          nextButton.disabled = values(currentKey).length === 0;
          nextButton.textContent = seq[index + 1] === GATE ? 'See my routine' : 'Next';
        }

        if (focusQuestion && activeEl) {
          const question = activeEl.querySelector('.tdog-quiz__question');
          if (question && typeof question.focus === 'function') question.focus({ preventScroll: true });
        }
      };

      const collectAnswers = () => {
        const cats = values('cats');
        return {
          cats: cats,
          skinType: cats.indexOf('face') > -1 ? single('face_type') : '',
          faceConcerns: cats.indexOf('face') > -1 ? values('face_concerns') : [],
          beardType: cats.indexOf('beard') > -1 ? single('beard_type') : '',
          beardConcerns: cats.indexOf('beard') > -1 ? values('beard_concerns') : [],
          bodyConcerns: cats.indexOf('body') > -1 ? values('body_concerns') : []
        };
      };

      /* ----- Recommendation engine ----- */

      const whyFor = (key, a) => {
        const fc = a.faceConcerns;
        const bc = a.beardConcerns;
        const has = (arr, v) => arr.indexOf(v) > -1;

        switch (key) {
          case 'cleanser':
            return WHY.cleanser;
          case 'toner': {
            let line;
            if (has(fc, 'dark_spots') || has(fc, 'texture')) line = WHY.toner_tone;
            else if (has(fc, 'breakouts')) line = WHY.toner_breakouts;
            else line = WHY.toner_tone;
            if (a.skinType === 'sensitive') line += WHY.toner_sensitive_note;
            return line;
          }
          case 'serum':
            if (has(fc, 'aging')) return WHY.serum_aging;
            if (has(fc, 'dark_spots') || has(fc, 'texture')) return WHY.serum_tone;
            if (has(fc, 'dryness')) return WHY.serum_dry;
            return WHY.serum_tone;
          case 'face_cream':
            if (has(fc, 'dryness')) return WHY.cream_dry;
            if (has(fc, 'aging')) return WHY.cream_aging;
            return WHY.cream_default;
          case 'eye_cream':
            if (has(fc, 'eyes')) return WHY.eye_eyes;
            return WHY.eye_aging;
          case 'beard_wash':
            return WHY.beard_wash;
          case 'beard_oil':
            if (has(bc, 'dry') || has(bc, 'itchy')) return WHY.beard_oil_dry;
            return WHY.beard_oil_default;
          case 'beard_scrub':
            if (has(bc, 'flakes') || has(bc, 'itchy')) return WHY.beard_scrub_flakes;
            return WHY.beard_scrub_grow;
          case 'body_wash':
            return WHY.body_wash;
          case 'body_lotion':
            if (has(a.bodyConcerns, 'dry')) return WHY.body_lotion_dry;
            return WHY.body_lotion_default;
          case 'face_bundle':
            return WHY.face_bundle;
          case 'beard_bundle':
            return WHY.beard_bundle;
          case 'full_bundle':
            return WHY.full_bundle;
          default:
            return '';
        }
      };

      const buildRecommendation = (a) => {
        const has = (arr, v) => arr.indexOf(v) > -1;
        const face = has(a.cats, 'face');
        const beard = has(a.cats, 'beard');
        const body = has(a.cats, 'body');
        const fc = a.faceConcerns;
        const bc = a.beardConcerns;

        const faceSet = [];
        if (face) {
          faceSet.push('cleanser');
          if (has(fc, 'breakouts') || has(fc, 'dark_spots') || has(fc, 'texture') || a.skinType === 'oily') {
            faceSet.push('toner');
          }
          if (
            has(fc, 'dark_spots') || has(fc, 'texture') || has(fc, 'aging') ||
            has(fc, 'breakouts') || has(fc, 'dryness') || has(fc, 'maintain')
          ) {
            faceSet.push('serum');
          }
          if (
            has(fc, 'dryness') || has(fc, 'aging') || has(fc, 'maintain') ||
            ['dry', 'normal', 'sensitive', 'combination'].indexOf(a.skinType) > -1
          ) {
            faceSet.push('face_cream');
          }
          if (has(fc, 'eyes') || has(fc, 'aging')) faceSet.push('eye_cream');
        }

        const beardSet = [];
        if (beard) {
          beardSet.push('beard_wash', 'beard_oil');
          if (
            has(bc, 'flakes') || has(bc, 'itchy') || has(bc, 'grow') ||
            a.beardType === 'full' || a.beardType === 'growing'
          ) {
            beardSet.push('beard_scrub');
          }
        }

        const bodySet = [];
        if (body) {
          bodySet.push('body_wash');
          if (has(a.bodyConcerns, 'dry') || has(a.bodyConcerns, 'maintain')) bodySet.push('body_lotion');
        }

        const faceFull = face && faceSet.length >= 4;
        const beardFull = beard && beardSet.indexOf('beard_scrub') > -1;
        const wantsEye = faceSet.indexOf('eye_cream') > -1;

        const entries = [];

        if (faceFull && beardFull) {
          entries.push({ key: 'full_bundle', kicker: KICKERS.headline, headline: true });
          if (wantsEye) entries.push({ key: 'eye_cream', kicker: KICKERS.addon });
        } else {
          if (face) {
            if (faceFull) {
              entries.push({ key: 'face_bundle', kicker: KICKERS.bundle });
              if (wantsEye) entries.push({ key: 'eye_cream', kicker: KICKERS.addon });
            } else {
              faceSet.forEach((k) => entries.push({ key: k, kicker: KICKERS.item }));
            }
          }
          if (beard) {
            if (beardFull) {
              entries.push({ key: 'beard_bundle', kicker: KICKERS.bundle });
            } else {
              beardSet.forEach((k) => entries.push({ key: k, kicker: KICKERS.item }));
            }
          }
          if (body) {
            bodySet.forEach((k) => entries.push({ key: k, kicker: KICKERS.item }));
          }
        }

        entries.forEach((entry) => {
          entry.why = whyFor(entry.key, a);
        });

        const hasBundle = entries.some((entry) => entry.key.indexOf('_bundle') > -1);
        const type = hasBundle ? 'bundle' : entries.length > 1 ? 'multi' : 'single';

        return { entries: entries, type: type };
      };

      /* ----- Summary line ----- */

      const listJoin = (arr) => {
        if (arr.length <= 1) return arr.join('');
        return arr.slice(0, -1).join(', ') + ' and ' + arr[arr.length - 1];
      };

      const buildSummary = (a) => {
        const has = (arr, v) => arr.indexOf(v) > -1;
        const skinLabels = {
          dry: 'dry',
          oily: 'oily',
          combination: 'combination',
          sensitive: 'sensitive',
          normal: 'balanced'
        };
        const faceConcernLabels = {
          breakouts: 'breakouts',
          dark_spots: 'dark spots',
          texture: 'dullness',
          dryness: 'dryness',
          aging: 'fine lines',
          eyes: 'tired eyes'
        };
        const beardTypeLabels = {
          stubble: 'stubble',
          medium: 'a medium beard',
          full: 'a full beard',
          growing: 'a beard you’re growing out'
        };
        const beardConcernLabels = {
          dry: 'dryness',
          itchy: 'itch',
          flakes: 'flakes',
          grow: 'patchy growth'
        };

        const parts = [];

        if (has(a.cats, 'face')) {
          let phrase = (skinLabels[a.skinType] || 'your') + ' skin';
          const concerns = a.faceConcerns
            .filter((c) => c !== 'maintain')
            .map((c) => faceConcernLabels[c])
            .filter(Boolean);
          if (concerns.length) phrase += ' with ' + listJoin(concerns);
          else phrase += ' you want to keep healthy';
          parts.push(phrase);
        }

        if (has(a.cats, 'beard')) {
          let phrase = beardTypeLabels[a.beardType] || 'your beard';
          const concerns = a.beardConcerns
            .filter((c) => c !== 'maintain')
            .map((c) => beardConcernLabels[c])
            .filter(Boolean);
          if (concerns.length) phrase += ' dealing with ' + listJoin(concerns);
          parts.push(phrase);
        }

        if (has(a.cats, 'body')) {
          parts.push(
            has(a.bodyConcerns, 'dry') ? 'daily body care for dry, rough skin' : 'a daily body clean'
          );
        }

        if (!parts.length) return 'Built around your answers.';
        return 'For ' + listJoin(parts) + '.';
      };

      /* ----- Tracking (guarded — never throws) ----- */

      const track = (email, answers, handles, type, products, summary, cartPath) => {
        const payload = {
          categories: answers.cats,
          skin_type: answers.skinType || '',
          beard_type: answers.beardType || '',
          face_concerns: answers.faceConcerns,
          beard_concerns: answers.beardConcerns,
          body_concerns: answers.bodyConcerns,
          recommendation: handles,
          recommendation_type: type,
          recommended_products: products || [],
          summary: summary || '',
          /* Cart permalink to his exact picks — the results email's
             "Shop my routine" button. cart_redirect is pre-encoded for
             use inside a /discount/CODE?redirect= link. */
          cart_path: cartPath || '',
          cart_url: cartPath ? window.location.origin + cartPath : '',
          cart_redirect: cartPath ? encodeURIComponent(cartPath) : ''
        };

        try {
          if (window.klaviyo && typeof window.klaviyo.push === 'function') {
            if (email) window.klaviyo.push(['identify', { $email: email }]);
            window.klaviyo.push(['track', 'Completed Routine Quiz', payload]);
          }
        } catch (error) {
          /* analytics must never block the quiz */
        }

        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(Object.assign({ event: 'tdog_quiz_complete' }, payload));
        } catch (error) {
          /* noop */
        }

        /* Shopify-side capture: creates/updates the customer with tags so
           quiz takers are segmentable in admin and by email tools even
           without Klaviyo. Fire-and-forget — never blocks the quiz. */
        try {
          if (email) {
            const fd = new FormData();
            fd.append('form_type', 'customer');
            fd.append('utf8', '✓');
            fd.append('contact[email]', email);
            fd.append('contact[tags]', 'quiz-taker' + (type && type !== 'none' ? ',quiz-' + type : ''));
            fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(() => {});
          }
        } catch (error) {
          /* capture must never block the quiz */
        }
      };

      /* ----- Result rendering ----- */

      const showResult = (email) => {
        const answers = collectAnswers();
        const recommendation = buildRecommendation(answers);
        const entries = recommendation.entries.filter((entry) => cards[entry.key]);

        Object.keys(cards).forEach((key) => {
          const el = cards[key];
          el.hidden = true;
          el.classList.remove('is-headline');
          el.style.order = '';
        });

        const shown = [];
        entries.forEach((entry, i) => {
          const el = cards[entry.key];
          el.hidden = false;
          el.style.order = String(i);
          if (entry.headline) el.classList.add('is-headline');
          const whyEl = el.querySelector('[data-tdog-why]');
          if (whyEl) whyEl.textContent = entry.why || '';
          const kickerEl = el.querySelector('[data-tdog-kicker]');
          if (kickerEl) kickerEl.textContent = entry.kicker || KICKERS.item;
          shown.push(el);
        });

        if (fallbackCard) fallbackCard.hidden = shown.length > 0;
        if (summaryEl) summaryEl.textContent = buildSummary(answers);

        if (addAllButton) {
          const addable = shown.filter(
            (el) => el.getAttribute('data-variant-id') && el.getAttribute('data-available') === 'true'
          );
          addAllButton.hidden = addable.length < 2;
        }
        if (addAllError) addAllError.hidden = true;

        quiz.classList.add('is-complete');
        result.hidden = false;

        const handles = shown.map((el) => el.getAttribute('data-handle')).filter(Boolean);
        /* Rich payload so the results email can mirror this screen exactly:
           every recommended product with its image, price, and the
           personalized "why" line, plus the summary sentence. */
        const productsPayload = entries.map((entry) => {
          const el = cards[entry.key];
          const img = el.querySelector('.tdog-quiz__rec-media img');
          const titleEl = el.querySelector('.tdog-quiz__rec-title');
          const priceEl = el.querySelector('.tdog-quiz__rec-price');
          const handle = el.getAttribute('data-handle') || '';
          return {
            title: titleEl ? titleEl.textContent.trim() : handle,
            url: handle ? window.location.origin + '/products/' + handle : window.location.origin + '/collections/all',
            image: img ? (img.currentSrc || img.src) : '',
            price: priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '',
            why: entry.why || ''
          };
        });
        /* Cart permalink: /cart/{variant}:1,... pre-loads his exact picks.
           storefront=true lands him on the cart page instead of checkout. */
        const cartIds = shown
          .filter((el) => el.getAttribute('data-variant-id') && el.getAttribute('data-available') === 'true')
          .map((el) => el.getAttribute('data-variant-id'));
        const cartPath = cartIds.length
          ? '/cart/' + cartIds.map((id) => id + ':1').join(',') + '?storefront=true'
          : '';
        track(email, answers, handles, shown.length ? recommendation.type : 'none', productsPayload, buildSummary(answers), cartPath);

        const heading = result.querySelector('.tdog-quiz__result-heading');
        if (heading && typeof heading.focus === 'function') heading.focus({ preventScroll: true });
        if (typeof result.scrollIntoView === 'function') {
          result.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
        }
      };

      /* ----- Add whole routine ----- */

      const setAddAllLoading = (loading) => {
        if (!addAllButton) return;
        addAllButton.classList.toggle('loading', loading);
        addAllButton.disabled = loading;
        const spinner = addAllButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !loading);
      };

      const addWholeRoutine = () => {
        if (!addAllButton || addAllButton.classList.contains('loading')) return;

        const shown = Object.keys(cards)
          .map((key) => cards[key])
          .filter(
            (el) =>
              !el.hidden &&
              el.getAttribute('data-variant-id') &&
              el.getAttribute('data-available') === 'true'
          )
          .sort((a, b) => Number(a.style.order || 0) - Number(b.style.order || 0));

        const ids = shown.map((el) => el.getAttribute('data-variant-id'));
        if (!ids.length) return;

        const addUrl = (quiz.getAttribute('data-cart-add-url') || '/cart/add') + '.js';
        const cartUrl = quiz.getAttribute('data-cart-url') || '/cart';
        const cartElement =
          document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        setAddAllLoading(true);
        if (addAllError) addAllError.hidden = true;

        const addOne = (i) => {
          const isLast = i === ids.length - 1;
          const body = { id: Number(ids[i]), quantity: 1 };
          if (isLast && cartElement && typeof cartElement.getSectionsToRender === 'function') {
            try {
              body.sections = cartElement.getSectionsToRender().map((s) => s.id);
              body.sections_url = window.location.pathname;
            } catch (error) {
              /* fall back to redirect below */
            }
          }

          return fetch(addUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(body)
          })
            .then((response) => response.json())
            .then((json) => {
              if (json && json.status) {
                throw new Error(json.description || json.message || 'Cart error');
              }
              if (!isLast) return addOne(i + 1);
              return json;
            });
        };

        addOne(0)
          .then((finalJson) => {
            setAddAllLoading(false);
            if (
              cartElement &&
              typeof cartElement.renderContents === 'function' &&
              finalJson &&
              finalJson.sections
            ) {
              try {
                cartElement.renderContents(finalJson);
              } catch (error) {
                window.location.href = cartUrl;
              }
            } else {
              window.location.href = cartUrl;
            }
          })
          .catch(() => {
            setAddAllLoading(false);
            if (addAllError) {
              addAllError.textContent =
                'We couldn’t add everything to your cart. Try adding the items individually.';
              addAllError.hidden = false;
            }
          });
      };

      /* ----- Events ----- */

      prevButton.addEventListener('click', () => {
        if (index === 0) return;
        hasNavigated = true;
        index -= 1;
        render(true);
      });

      nextButton.addEventListener('click', () => {
        const seq = buildSequence();
        if (values(seq[index]).length === 0) return;
        if (index < seq.length - 1) {
          hasNavigated = true;
          index += 1;
          render(true);
        }
      });

      quiz.addEventListener('change', (event) => {
        if (!event.target || !event.target.closest('[data-tdog-step]')) return;
        render(false);
      });

      gateInput.addEventListener('input', () => {
        if (gateError && !gateError.hidden) {
          gateError.hidden = true;
          gateInput.removeAttribute('aria-invalid');
        }
      });

      gateForm.addEventListener('submit', (event) => {
        event.preventDefault();
        const email = (gateInput.value || '').trim();
        if (!EMAIL_RE.test(email)) {
          if (gateError) gateError.hidden = false;
          gateInput.setAttribute('aria-invalid', 'true');
          gateInput.focus();
          return;
        }
        if (gateError) gateError.hidden = true;
        gateInput.removeAttribute('aria-invalid');
        showResult(email);
      });

      if (addAllButton) addAllButton.addEventListener('click', addWholeRoutine);

      if (restartButton) {
        restartButton.addEventListener('click', () => {
          quiz.querySelectorAll('[data-tdog-step] input[type="checkbox"], [data-tdog-step] input[type="radio"]').forEach((input) => {
            input.checked = false;
          });
          index = 0;
          hasNavigated = false;
          quiz.classList.remove('is-complete');
          result.hidden = true;
          if (addAllError) addAllError.hidden = true;
          if (gateError) gateError.hidden = true;
          gateInput.removeAttribute('aria-invalid');
          render(false);
          if (typeof quiz.scrollIntoView === 'function') {
            quiz.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
          }
        });
      }

      render(false);

      /* Pre-answer Q1 from ?focus=face|beard|body (quiz popup handoff) —
         lands the visitor on question 2, already in motion. */
      try {
        const focusParam = new URLSearchParams(window.location.search).get('focus');
        if (focusParam) {
          const wanted = focusParam
            .split(',')
            .map((s) => s.trim().toLowerCase())
            .filter((s) => ['face', 'beard', 'body'].indexOf(s) > -1);
          const catsEl = stepEl('cats');
          if (wanted.length && catsEl) {
            catsEl.querySelectorAll('input').forEach((input) => {
              input.checked = wanted.indexOf(input.value) > -1;
            });
            index = 1;
            hasNavigated = true;
            render(false);
            window.setTimeout(() => {
              if (typeof quiz.scrollIntoView === 'function') {
                quiz.scrollIntoView({ behavior: 'auto', block: 'start' });
              }
            }, 60);
          }
        }
      } catch (e) {
        /* no-op: quiz still works from question 1 */
      }
    };

    document.querySelectorAll('[data-tdog-quiz]').forEach(initQuiz);

    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target) return;
      const quiz = event.target.querySelector('[data-tdog-quiz]');
      if (quiz) initQuiz(quiz);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
